module.exports = __webpack_public_path__ + "img/歸戶提示_m.3b6db386.png";